const translations = {
    addressOneFieldLabel: 'Address One'
};

export default translations;
